import { LoginCredentials } from '../types/auth';
import httpClient from './httpClient';
import { AxiosError } from 'axios';

export const loginUser = async (credentials: LoginCredentials) => {
  const response = await httpClient.post('/api/auth/login', credentials);

  // Guardar el token en localStorage
  if (response.data.token) {
    localStorage.setItem('token', response.data.token);
  }

  // Return full response data including tenants (if present for programer users)
  return response.data;
};

export const verifyToken = async (token: string) => {
  try {
    const response = await httpClient.get('/api/auth/verify', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const userData = response.data;
    return {
      id: userData.id || userData._id,
      nombre: userData.nombre,
      email: userData.email,
      role: userData.role,
      isSystemUser: userData.isSystemUser,
      tenantId: userData.tenantId
    };
  } catch (error) {
    if ((error as AxiosError)?.response?.status === 401) {
      throw new Error('Token expirado o inválido');
    } else if ((error as AxiosError)?.response?.status === 404) {
      throw new Error('Usuario no encontrado');
    } else {
      throw new Error(`Error en la verificación: ${(error as AxiosError)?.response?.status || 'desconocido'}`);
    }
  }
};

export const refreshToken = async (token: string) => {
  try {
    const response = await httpClient.post('/api/auth/refresh', null, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const newToken = response.data.token;
    if (newToken) {
      localStorage.setItem('token', newToken);
    }
    return newToken;
  } catch (error) {
    throw new Error('No se pudo renovar el token');
  }
};
